import React, { useState, useEffect, useRef } from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import { PricingTables, PaymentForm, PaymentSuccess, ChangeCurrency } from 'components/payment/index.js';

// The nesting counterpart of the dieline's redraw-denied popup. When a
// non-entitled user tries to redraw a nesting layout, LayoutActions#redraw_layout
// answers with a redraw_denied response; components/layout/LayoutSvg.jsx clears the
// canvas and dispatches 'layouts.nesting_purchase_required', which opens this
// popup. Nesting is also sold via Credit Packs, so the pricing tables keep the
// Credit Packages / Subscriptions toggle (no hideCredits) — matching the dieline.
const NestingPurchaseRequired = ({}) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const popupRef = useRef();

  const [mode, setMode] = useState('pricing_tables');
  const [subscription, setSubscription] = useState({});
  const [currencyName, setCurrencyName] = useState('');

  const performShowPopup = () => {
    setMode(() => 'pricing_tables');
    setShowPopUp(() => true);
  };

  useEffect(() => {
    let listen = 'layouts.nesting_purchase_required';
    document.addEventListener(listen, performShowPopup);
    return () => { document.removeEventListener(listen, performShowPopup); };
  }, []);

  useEffect(() => {
    if(!showPopUp) { return; }
    if(mode != 'pricing_tables') { return; }

    trackEvent('js_purchase_required_popup', {
      feature: 'nesting',
      component: 'layout/NestingPurchaseRequired',
      id: window.drawingId,
    });
  }, [showPopUp, mode]);

  const handleBackClick = (e) => {
    e.preventDefault();
    setMode('pricing_tables');
  };

  const backButton = () => {
    return (
      <span style={{'display':'inline', 'float':'right'}}>
        &nbsp;
        &nbsp;
        &nbsp;
        <button className="btn simple-btn" onClick={handleBackClick}>
          <i className="zmdi zmdi-replay"></i> {t('nav.back')}
        </button>
      </span>
    );
  };

  const popupContent = () => {
    // After a successful purchase the user is entitled, so reload the page: the
    // nesting tool comes back live and their next redraw is honoured.
    let reload = () => { window.location.reload(); };

    let content = (
      <div className="testimonials-block preview-promo-block">
        <span className="testimonials-desc" dangerouslySetInnerHTML={{__html: t('layouts.nesting_purchase_required')}}></span>
        <div className="testimonials-desc testimonials-desc-pricing">
          {mode == 'payment_form' && backButton() }
          {mode == 'payment_form' && <ChangeCurrency currencyName={currencyName} mode={mode} />}
          {mode == 'payment_success' && <PaymentSuccess callback={reload} />}
          {mode == 'pricing_tables' && <PricingTables setMode={setMode} setSubscription={setSubscription} setCurrencyName={setCurrencyName} currencySelector={<ChangeCurrency currencyName={currencyName} mode={mode} />} disabledTiers={['starter']} disabledTierNote={t('layouts.nesting_not_included')} /> }
          {mode == 'payment_form'   && <PaymentForm setMode={setMode} subscription={subscription} setSubscription={setSubscription} setCurrencyName={setCurrencyName} /> }
        </div>
      </div>
    );

    return <ContentPopup
      contextClass="wrapper"
      myRef={popupRef}
      autoOpen={true}
      content={content}
      cancelButton={false}
      beforeClose={() => setShowPopUp(() => false)}
      notWide={true}
      modalClass={mode == 'pricing_tables' ? 'modal-content-pricing-cards' : ''}
    />;
  };

  return (
    <div>
      {showPopUp && popupContent()}
    </div>
  );
};

export default NestingPurchaseRequired;
